import { format, formatDistanceToNow, type Locale } from "date-fns"
import {
  de as deLocale,
  enUS,
  fi as fiLocale,
  nb as noLocale,
  sv as svLocale,
} from "date-fns/locale"

const DATE_LOCALES: Record<string, Locale> = {
  sv: svLocale,
  en: enUS,
  no: noLocale,
  de: deLocale,
  fi: fiLocale,
}

/** Resolve a date-fns locale from an i18n language tag (e.g. "sv-SE" → sv). */
export function getDateFnsLocale(language: string): Locale {
  const base = language.split("-")[0] ?? "en"
  return DATE_LOCALES[base] ?? enUS
}

function parseIsoDate(iso: string): Date | null {
  if (!iso) return null
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? null : date
}

/** Absolute date for deck/presentation cards — e.g. "Jun 3, 2026". */
export function formatSlideSenseDate(iso: string, language: string): string {
  const date = parseIsoDate(iso)
  if (!date) return ""
  return format(date, "PP", { locale: getDateFnsLocale(language) })
}

/**
 * Compact relative date for landing cards: distance-with-suffix within 30 days,
 * absolute date thereafter (matches prior SlideHubLanding behaviour).
 */
export function formatSlideSenseRelativeDate(iso: string, language: string): string {
  const date = parseIsoDate(iso)
  if (!date) return ""
  const days = Math.floor((Date.now() - date.getTime()) / 86400000)
  const locale = getDateFnsLocale(language)
  if (Math.abs(days) < 30) {
    return formatDistanceToNow(date, { addSuffix: true, locale })
  }
  return format(date, "PP", { locale })
}
